module.exports = __webpack_public_path__ + "static/hero-0bb8c099cda6100410f5fad679c5c45e.png";